// todo This is actually not just breadcrumbs, but something more, which
//      is why I think we should rename this component or move the non-
//      breadcrumb logic to a different component.
// import { getLastPortfolioPath, teamPathParameterName } from '../../RootPaths';
// import getTheTail from './utils/getTheTail';
import { useCallback, useRef, useState } from 'react';
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { tss } from 'tss-react/mui';
import { Box, paperClasses, styled, useMediaQuery } from '@mui/material';
import type { Theme } from '@mui/material';
import { ArrowLeftIcon } from '../icons';
import ToggleArrowsUpAndDown from '../ToggleArrowsUpAndDown';
import StyledPopper from '../StyledPopper';

const MainLabel = styled('div')(({ theme }) => ({
    color: theme.palette.text.primary,
    textDecoration: 'none',
    fontSize: 24,
    lineHeight: 1.25,
    fontWeight: 'bold',
    display: 'block',
    letterSpacing: 0.6,
    paddingRight: theme.spacing(1),
    // Ensures we fit the element to the content for wrapped text, but it does not work
    width: 'min-content',
    minWidth: 'fit-content',
    [theme.breakpoints.down('sm')]: {
        fontSize: 18,
    },
}));
const useBreadcrumbStyles = tss.create(({ theme }) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        lineHeight: 1,
        '& svg': {
            color: theme.palette.text.secondary,
        },
    },
    root_mobile: {
        '& a': {
            textDecoration: 'none',
            fontSize: 12,
            display: 'inline-block', // Needed or line-height is not respected
        },
    },

    subSectionLabel: {
        textDecoration: 'none',
        fontSize: 14,
        lineHeight: 1.25,

        fontWeight: 'normal',
        display: 'inline-block',
        paddingRight: 5,
    },
    subSectionText: {
        color: theme.palette.text.secondary,
    },
    delimiter: {
        color: theme.palette.text.secondary,
        paddingLeft: 5,
    },
}));

export type BreadcrumbsProps = {
    crumbs: { to?: string; label: ReactNode }[];
    mobile?: boolean;
    renderIcon?: () => ReactNode;
    dropDownContent?: ReactNode | null | undefined;
};

export function Breadcrumbs(props: BreadcrumbsProps) {
    const {
        mobile,
        crumbs: originalCrumbs,
        renderIcon,
        dropDownContent,
    } = props;
    const crumbsWithoutLastItem = originalCrumbs && [...originalCrumbs];
    const { classes } = useBreadcrumbStyles();
    const isSmallScreen = useMediaQuery<Theme>(
        (theme) => theme.breakpoints.down('sm'),
        {
            // https://github.com/mui-org/material-ui/issues/21048
            noSsr: true,
        },
    );

    // const location = useLocation();
    // const params = useParams();

    const openPopUpRef = useRef(null);
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const onToggle = useCallback(() => {
        setIsOpen((prev) => !prev);
    }, []);

    if (!crumbsWithoutLastItem || crumbsWithoutLastItem.length === 0) {
        return null;
    }
    const theLastItem = crumbsWithoutLastItem.pop();

    const isMobile = mobile == null ? isSmallScreen : mobile;

    // const teamPath: string = params[teamPathParameterName] ?? '';
    // const lastPortfolioName = getLastPortfolioPath(params);
    // const theLastParameterName: string =
    //     lastPortfolioName !== '' ? lastPortfolioName : teamPath;
    //
    //    const tail = getTheTail(location.pathname, theLastParameterName);
    const getNewUrl = (to: string) => to; //`${to}${tail && '/' + tail}`;

    return (
        <Box
            className={`${classes.root} ${isMobile ? classes.root_mobile : ''}`}
        >
            {renderIcon ? renderIcon() : <ArrowLeftIcon size={12} />}

            {!!crumbsWithoutLastItem.length && (
                <div>
                    {crumbsWithoutLastItem.map(({ to, label }) => {
                        const newUrl = getNewUrl(to);

                        return label ? (
                            <span
                                key={label + to}
                                className={classes.subSectionLabel}
                            >
                                <Link
                                    to={newUrl}
                                    className={classes.subSectionText}
                                >
                                    {label}
                                </Link>
                                <span className={classes.delimiter}>/</span>
                            </span>
                        ) : null;
                    })}
                </div>
            )}
            <Box
                display="flex"
                flexWrap="nowrap"
                sx={dropDownContent ? { cursor: 'pointer' } : undefined}
                onClick={dropDownContent ? onToggle : undefined}
            >
                <MainLabel ref={openPopUpRef}>{theLastItem.label}</MainLabel>
                {dropDownContent && (
                    <>
                        <Box
                            alignSelf="center"
                            data-testid="dropDown-data-testid"
                        >
                            <ToggleArrowsUpAndDown toggle={isOpen} size={12} />
                        </Box>
                        <StyledPopper
                            open={isOpen}
                            onClose={() => setIsOpen(false)}
                            anchorEl={openPopUpRef.current}
                            sx={{
                                zIndex: 20, // todo be more specific using the theme zIndex breakpoints
                                [`& .${paperClasses.root}`]: {
                                    p: 0,
                                },
                            }}
                        >
                            {dropDownContent}
                        </StyledPopper>
                    </>
                )}
            </Box>
        </Box>
    );
}

export default Breadcrumbs;
